import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { UpdateDressCodeAction } from '../../actions/dress-code/update-dress-code-action';
import { UpdateDressCodeErrorAction } from '../../actions/dress-code/update-dress-code-error-action';
import { GetDressCodeAction } from '../../actions/dress-code/get-dress-code-action';

@Injectable()
export class UpdateDressCodeEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public UpdateDressCode = createEffect(() => this.actions
    .pipe(
      ofType(UpdateDressCodeAction.type),
      mergeMap(action => {
        const updateDressCodeAction = <UpdateDressCodeAction>action;
        return this.api.updateDressCode(updateDressCodeAction.dressCode).then(() => {
          return new GetDressCodeAction(updateDressCodeAction.bijbEvent);
        }, error => {
          return new UpdateDressCodeErrorAction(error);
        });
      })
    ));
}
